// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zappyride_incentive_web--ReportPage-module--headerContainer--Yzm4BrrSZ8xCIE_oU_b5 {
  margin-top: 12px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: var(--font-sizebodyregularM);
  font-weight: 400;
  line-height: var(--line-heightbodyregularM);
  text-align: left;
  text-underline-position: from-font;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}`, "",{"version":3,"sources":["webpack://./src/components/ReportGenerator/ReportPage.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,gBAAA;EACA,2CAAA;EACA,gBAAA;EACA,kCAAA;EACA,sCAAA;UAAA,8BAAA;AACJ","sourcesContent":[".headerContainer {\n    margin-top: 12px;\n    margin-bottom: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: var(--font-sizebodyregularM);\n    font-weight: 400;\n    line-height: var(--line-heightbodyregularM);\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": `zappyride_incentive_web--ReportPage-module--headerContainer--Yzm4BrrSZ8xCIE_oU_b5`
};
export default ___CSS_LOADER_EXPORT___;
